import {
  Flex,
  FormControl,
  Text,
} from "@chakra-ui/react";
import { Input as InputBarte } from "barte-design-system";

interface TextAreaProps {
  opcional?: boolean;
  label?: string;
  errors?: any;
  register?: any;
  labelFontSize?: string;
  labelColor?: string;
  currentLength?: number;
  maxLengthBlocks?: boolean;
  maxLength?: number | null;
  isDisabled?: boolean;
  placeholder?: string;
  value?: string;
  defaultValue?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  name?: string;
  className?: string;
  helpText?: string;
  icon?: React.ReactNode;
  [key: string]: any;
}

const TextArea = ({
  opcional,
  label,
  register,
  errors,
  className,
  labelFontSize,
  labelColor,
  maxLength = null,
  currentLength,
  maxLengthBlocks = false,
  helpText,
  icon,
  ...rest
}: TextAreaProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (rest?.onChange) {
      rest.onChange(e);
    }
    if (register?.onChange) {
      register.onChange(e);
    }
  };

  // Props que o InputBarte aceita
  const inputBarteProps: any = {
    type: "textarea",
    label: label,
    labelOptional: opcional ? "(opcional)" : undefined,
    helpText: helpText,
    placeholder: rest?.placeholder,
    error: errors?.message,
    icon: icon,
    className: className,
    disabled: rest?.isDisabled,
    maxLength: (maxLength && maxLengthBlocks) ? maxLength : undefined,
  };

  // Props do register e eventos que precisam ser passados para o textarea interno
  const textareaEvents = {
    name: rest?.name,
    onChange: handleChange,
    value: rest?.value,
    defaultValue: rest?.defaultValue,
    ...(register || {}),
  };

  return (
    <FormControl isInvalid={!!errors?.message}>
      <Flex flexDir="column">
        <InputBarte
          {...inputBarteProps}
          {...textareaEvents}
        />
        {(currentLength !== undefined && currentLength >= 0 && maxLength && !rest?.isDisabled) && (
          <Text 
            color={currentLength > maxLength ? "red.400" : "gray.200"}
            fontSize=".6rem"
            textAlign="right"
            mt=".2rem"
          >
            {currentLength}/{maxLength}
          </Text>
        )}
      </Flex>
    </FormControl>
  );
};

export { TextArea };
